import { lazy } from 'react';
import i18next from 'i18next';
import { OrdersIcon } from '@shared/ui/icons';

// FSD migration in progress: Order Edit lives under `src/pages/order-edit`;
// Order Create migrated to `@features/create-order` (SidePanel) — no
// dedicated page / route exists for Create / Reorder anymore.
const OrderEdit = lazy(() => import('../../../../../pages/order-edit'));
const Orders = lazy(() => import('../../../../../pages/orders'));

// const ORDER_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/orders',
//   exact: true,
//   additional: {
//     component: Orders,
//     protected: true,
//     title: i18next.t('titles:orders'),
//     icon: OrdersIcon,
//   },
// };

const ORDER_ROUTE_LIST = {
  path: '/:currentAccountUuid/orders',
  exact: true,
  additional: {
    component: Orders,
    protected: true,
    title: i18next.t('titles:orders'),
    icon: OrdersIcon,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.orders || 'Orders',
    },
  },
};

const ORDER_ROUTE_EDIT_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/patients/:patientUuid/orders/:orderUuid/edit',
  exact: true,
  parentRoute: ORDER_ROUTE_LIST, //ORDER_ROUTE_LIST_DS,
  additional: {
    component: OrderEdit,
    protected: true,
    title: i18next.t('titles:editOrder'),
    breadcrumb: {
      isRoot: false,
      parentPath: '/:currentAccountUuid/orders',
      label: ({ state }) => state.i18n?.en?.titles?.order || 'Order',
      replaceSibling: true,
    },
  },
};

const ORDER_ROUTE_EDIT = {
  path: '/:currentAccountUuid/patients/:patientUuid/orders/:orderUuid/edit',
  exact: true,
  parentRoute: ORDER_ROUTE_LIST,
  additional: {
    component: OrderEdit,
    protected: true,
    title: i18next.t('titles:editOrder'),
    breadcrumb: {
      isRoot: false,
      parentPath: '/:currentAccountUuid/orders',
      label: ({ state }) => state.i18n?.en?.titles?.order || 'Order',
      replaceSibling: true,
    },
  },
};

export const ORDER_ROUTES = {
  // ------- For child accounts ------
  // listDS: ORDER_ROUTE_LIST_DS,
  editDS: ORDER_ROUTE_EDIT_DS,

  // ------- For current accounts ------
  list: ORDER_ROUTE_LIST,
  edit: ORDER_ROUTE_EDIT,
};
